import React, {useState, useEffect} from 'react'
import './RecipientTypeList.scss'
import Item from './Item'
import type {RecipientType, WhoToAddKey} from '../QuickSelect'

interface Props {
  types: RecipientType[]
  selected: WhoToAddKey
  onSelect: (type: RecipientType) => void
}

const MOBILE_QUERY = '(max-width: 720px)'

const RecipientTypeList = ({types, selected, onSelect}: Props) => {
  const [isHorizontal, setIsHorizontal] = useState(() => window.matchMedia(MOBILE_QUERY).matches)

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY)
    const handler = () => setIsHorizontal(mql.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return (
    <div
      role="listbox"
      aria-orientation={isHorizontal ? 'horizontal' : 'vertical'}
      aria-label="Recipient type"
      className="list"
    >
      {types.map((type) => (
        <Item
          key={type.key}
          onClick={() => {
            onSelect(type)
          }}
          iconName={type.iconName}
          title={type.description}
          selected={selected === type.key}
        />
      ))}
    </div>
  )
}

export default RecipientTypeList
